export const getNumberOfDecimals = (input) => {
    if (input) {
        const converted = input.toString();
        if (converted.includes('.')) {
            return converted.split('.')[1].length;
        }
        ;
    }
    return 0;
};
